import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/style/style.css';

const features = [
    {
        icon: '🔥',
        title: '프라이빗 바베큐',
        desc: '각 별채마다 독립된 개인 바베큐장.\n숯불 이용 시 미리 말씀해 주세요.',
    },
    {
        icon: '🌿',
        title: '아름다운 자연 정원',
        desc: '사계절 꽃이 피는 정원과\n아이들 트램폴린이 준비되어 있습니다.',
    },
    {
        icon: '🍺',
        title: '편의시설 완비',
        desc: '매점, 백숙, 치킨, 커피, 생맥주까지.\n몸만 오시면 됩니다!',
    },
];

const Main = () => {
    return (
        <div className="main-wrapper">
            {/* Hero Banner */}
            <section className="main-banner">
                <div className="banner-overlay">
                    <div className="banner-text">
                        <div className="banner-actions">
                            <Link to="/reservation" className="banner-cta">예약하기</Link>
                        </div>
                    </div>
                </div>
            </section>

            <div className="main-container">
                {/* Information */}
                <div className="section-header">
                    <span className="section-label">INFORMATION</span>
                    <h2 className="section-title">자연이 선물하는 특별한 휴식</h2>
                    <p className="section-desc">
                        자연 속에서 쉬어가는 따뜻한 공간, 물조은 펜션.<br/>
                        가족, 친구, 연인과 함께 머물기 좋은 아늑한 쉼터.<br/>
                        언제 찾아도 편안하고 정겨운 당신만의 힐링 플레이스.
                    </p>
                </div>

                {/* Feature Cards */}
                <div className="feature-cards">
                    {features.map(({ icon, title, desc }) => (
                        <div key={title} className="feature-card">
                            <span className="feature-icon">{icon}</span>
                            <h3 className="feature-title">{title}</h3>
                            <p className="feature-desc">{desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Main;
